import React, { useEffect, useState, useRef, Fragment, memo, createElement } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Zap, Target, CheckCircle2, Star, Users, Gift, Sparkles, Flower, MessageSquare, Clock } from 'lucide-react';
import { useMotionValue, useTransform, animate, useInView, AnimatePresence } from 'framer-motion';
import { UrgencyBanner } from './components/UrgencyBanner';
import { BonusCard } from './components/BonusCard';
import { Reviews } from './components/Reviews';
import { FAQ } from './components/FAQ';
import { WhatYouReceive } from './components/WhatYouReceive';
import { MagicalBackground } from './components/MagicalBackground';
import { InfraestructuraSistemica } from './components/InfraestructuraSistemica';
import { DiferencialHibrido } from './components/DiferencialHibrido';
import { PremiumCTA } from './components/PremiumCTA';
import { PainPoints } from './components/PainPoints';
import { TherapistPresentation } from './components/TherapistPresentation';
function AnimatedCounter({
  from,
  to
}: {
  from: number;
  to: number;
}) {
  const count = useMotionValue(from);
  const rounded = useTransform(count, latest => {
    return Math.round(latest).toLocaleString('es-AR');
  });
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true
  });
  useEffect(() => {
    if (isInView) {
      const controls = animate(count, to, {
        duration: 1.5,
        ease: 'easeOut'
      });
      return controls.stop;
    }
  }, [to, isInView]);
  return <motion.span ref={ref} data-id="element-0" data-mp="33myjb79kwfrj">{rounded}</motion.span>;
}
const testimonials = [{
  name: 'Beatriz',
  loc: 'Buenos Aires',
  badge: 'Terapeuta Holística',
  text: 'A mis 55 años, buscaba algo que realmente le diera un marco profesional a mis lecturas. El sistema de interpretación terapéutica es oro puro; me dio la estructura que me faltaba para mis sesiones individuales.'
}, {
  name: 'Silvia',
  loc: 'Córdoba Capital',
  badge: 'Lectora Profesional',
  text: 'El manual fundamental cambió totalmente la profundidad de mis lecturas. Las preguntas de exploración generan un clima de confianza y descubrimiento inmediato que mis consultantes agradecen muchísimo.'
}, {
  name: 'Claudia',
  loc: 'Rosario',
  badge: 'Facilitadora de Tarot',
  text: 'Los métodos de tiradas terapéuticas son los más potentes que he usado en mis 15 años de carrera. Mis consultantes están fascinados con la claridad y precisión de los procesos emocionales que logramos.'
}, {
  name: 'Marcela',
  loc: 'Mendoza',
  badge: 'Psicóloga Holística',
  text: 'El diario de interpretación es la herramienta perfecta para que el proceso terapéutico siga trabajando entre sesiones. A mis 50 años, valoro tener materiales tan bien organizados y profesionales.'
}, {
  name: 'Adriana',
  loc: 'Salta',
  badge: 'Terapeuta Energética',
  text: 'El protocolo de protección energética me salvó. Antes terminaba agotada después de cada lectura, ahora sé cómo sostener mi energía y mi lugar como profesional sin cargar con lo ajeno.'
}];
export function App() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [spots, setSpots] = useState(18);
  const [joinedCount, setJoinedCount] = useState(3265);
  const [viewers, setViewers] = useState(48);
  const [showSaleAnimations, setShowSaleAnimations] = useState(false);
  const [selectedOption, setSelectedOption] = useState(1);
  const [selectedKit, setSelectedKit] = useState(1);
  const [timeLeft, setTimeLeft] = useState({
    minutes: 14,
    seconds: 15
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.minutes === 0 && prev.seconds === 0) return prev;
        const totalSeconds = prev.minutes * 60 + prev.seconds - 1;
        return {
          minutes: Math.floor(totalSeconds / 60),
          seconds: totalSeconds % 60
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const viewerInterval = setInterval(() => {
      setViewers(prev => prev + (Math.random() > 0.5 ? 1 : -1));
    }, 3000);
    return () => clearInterval(viewerInterval);
  }, []);
  useEffect(() => {
    // Meta Pixel Integration
    const pixelId = '1051253568074079';
    // @ts-ignore
    if (!window.fbq) {
      // @ts-ignore
      !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        b.head.appendChild(t);
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    }
    // @ts-ignore
    window.fbq('init', pixelId);
    // @ts-ignore
    window.fbq('track', 'PageView');
  }, []);
  const handleSale = () => {
    setSpots(prev => prev > 2 ? prev - 1 : prev);
    setJoinedCount(prev => prev + 1);
    setShowSaleAnimations(true);
    setTimeout(() => setShowSaleAnimations(false), 2000);
  };
  const nextTestimonial = () => {
    setCurrentTestimonial(prev => (prev + 1) % testimonials.length);
  };
  const prevTestimonial = () => {
    setCurrentTestimonial(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };
  const currentDate = new Date().toLocaleDateString('es-AR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  const scrollToPurchase = () => {
    document.getElementById('purchase')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const options = [{
    id: 1,
    name: 'SOLO TAROT TERAPÉUTICO PROFESIONAL',
    price: '19.990',
    oldPrice: '39.990',
    description: 'Guía Tarot Terapéutico Profesional PDF + 4 Bonos',
    badge: null,
    link: 'https://codex-labs.shop/cart/43501032210491:1',
    image: 'https://cdn.magicpatterns.com/uploads/cfQrdUBoTmXeXJSpkVXJys/Libro_Tarot_Terapeutico_Profesio%E2%80%A6_202605101407.jpg'
  }, {
    id: 2,
    name: 'GUÍA TAROT + 1 KIT OPCIONAL',
    price: '29.990',
    oldPrice: '59.990',
    description: 'Elegí un kit adicional para complementar tu formación',
    badge: 'MÁS ELEGIDO',
    link: 'https://codex-labs.shop/cart/43501032210491:1',
    image: 'https://cdn.magicpatterns.com/uploads/cfQrdUBoTmXeXJSpkVXJys/Libro_Tarot_Terapeutico_Profesio%E2%80%A6_202605101407.jpg'
  }, {
    id: 3,
    name: 'PORTAL TERAPÉUTICO COMPLETO',
    price: '39.990',
    oldPrice: '79.990',
    description: 'Acceso total: Tarot + Astrología + Oráculos + Todos sus bonos',
    badge: 'MEJOR VALOR 🔥',
    link: 'https://codex-labs.shop/cart/43552261701691:1',
    image: 'https://cdn.magicpatterns.com/uploads/mFrm64tQpe7hQwSWq3q2MN/ChatGPT_Image_27_may_2026,_15_23_37.webp'
  }];
  const kits = [{
    id: 1,
    name: 'Kit Radiestesia Profesional',
    icon: '🧭',
    image: 'https://cdn.magicpatterns.com/uploads/8PWsZFc7Y8fkB4gNm7n2Go/ChatGPT_Image_29_may_2026,_10_34_17.webp',
    link: 'https://codex-labs.shop/cart/43555165241403:1'
  }, {
    id: 2,
    name: 'Kit Reiki Profesional',
    icon: '🧘',
    image: 'https://cdn.magicpatterns.com/uploads/ns2b3sniNi2Nbm1mjisoR2/27_may_2026,_15_44_23.webp',
    link: 'https://codex-labs.shop/cart/43552284147771:1'
  }, {
    id: 3,
    name: 'Kit Constelaciones Familiares',
    icon: '👥',
    image: 'https://cdn.magicpatterns.com/uploads/r8koKT3rvQfsMW3Yo51kEd/6e7f317b-cb85-4de6-a3fe-bd663b8856bd.webp',
    link: 'https://codex-labs.shop/cart/43553649524795:1'
  }];
  const selectedData = options.find(o => o.id === selectedOption) || options[0];
  const currentKit = kits.find(k => k.id === selectedKit) || kits[0];
  const displayImage = selectedOption === 2 ? currentKit.image : selectedData.image;
  const finalLink = selectedOption === 2 ? currentKit.link : selectedData.link;
  return <div className="min-h-screen bg-[#fdfbf7] text-[#2d2d2d] font-sans selection:bg-purple-200 selection:text-purple-900" data-id="element-1" data-mp="2qvmp66qyqi3z">
      <MagicalBackground data-id="element-2" data-mp="2m0h41a5dx7gy" />
      <UrgencyBanner spots={spots} onSale={handleSale} viewers={viewers} data-id="element-3" data-mp="2hw9ghganxxkb" />

      {/* Hero Section */}
      <header className="relative w-full group" data-id="element-4" data-mp="2d59i06lwb7fp">
        <img src="https://cdn.magicpatterns.com/uploads/8WRCxHFHtHPwVc4p7Bjdbb/ChatGPT_Image_7_ago_2026,_16_21_25.webp" alt="Interpretá cualquier carta con confianza y transformá vidas - Tarot Terapéutico Profesional" className="w-full h-auto mb-[0px]" data-id="element-5" data-mp="2d4hy3t1nuy59" />

        {/* Premium Holographic CTA Button — overlaid on top of painted button area */}
        <div className="absolute bottom-[0.2%] left-1/2 -translate-x-1/2 w-[88%] z-30" data-id="element-6" data-mp="1u888q9lb6l5y">
          <motion.button onClick={scrollToPurchase} whileHover={{
          scale: 1.01
        }} whileTap={{
          scale: 0.98
        }} aria-label="Quiero transformar mi don" className="group/btn relative w-full cursor-pointer" style={{
          aspectRatio: '5.2 / 1'
        }} data-id="element-7" data-mp="9nuu3hfw69s5">
            {/* Holographic iridescent border (animated gradient) */}
            <span className="absolute inset-0 rounded-[14px] p-[1.5px] opacity-100 group-hover/btn:opacity-100 transition-opacity duration-500" style={{
            background: 'linear-gradient(120deg, #b794f4 0%, #f0abfc 18%, #fde68a 36%, #5eead4 54%, #93c5fd 72%, #c4b5fd 90%, #f0abfc 100%)',
            backgroundSize: '300% 300%',
            animation: 'mp-holo-shift 8s linear infinite'
          }} data-id="element-8" data-mp="3r54h3sxx3385">
              {/* Inner dark fill */}
              <span className="block w-full h-full rounded-[12px] bg-black" data-id="element-9" data-mp="2f63lbu191meh" />
            </span>

            {/* Outer glow on hover */}
            <span className="pointer-events-none absolute -inset-2 rounded-[20px] opacity-0 group-hover/btn:opacity-70 blur-xl transition-opacity duration-500" style={{
            background: 'linear-gradient(120deg, rgba(183,148,244,0.5), rgba(94,234,212,0.5), rgba(147,197,253,0.5))'
          }} data-id="element-10" data-mp="2k8b2cy0xrsno" />

            {/* Label + sparkles */}
            <span className="absolute inset-0 flex items-center justify-center px-4 gap-[20px]" data-id="element-11" data-mp="21dm7j46weym8">
              <span aria-hidden="true" className="text-[#fde68a] text-base md:text-2xl drop-shadow-[0_0_6px_rgba(253,224,138,0.6)]" data-id="element-12" data-mp="26cqm6acldojy">
                ✦
              </span>
              <span className="font-black uppercase tracking-[0.18em] md:text-xl text-[10.5px]" style={{
              background: 'linear-gradient(90deg, #c4b5fd 0%, #fde68a 50%, #93c5fd 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }} data-id="element-13" data-mp="1ip8vyj8z6yj3">
                QUIERO TRANSFORMAR MI DON
              </span>
              <span aria-hidden="true" className="text-[#fde68a] text-base md:text-2xl drop-shadow-[0_0_6px_rgba(253,224,138,0.6)]" data-id="element-14" data-mp="3d0mn0ls1vd8g">
                ✦
              </span>
            </span>

            {/* Shine sweep — runs every ~4.5s */}
            <span className="absolute inset-0 overflow-hidden rounded-[14px] pointer-events-none" data-id="element-15" data-mp="345yjb024i3lr">
              <span className="absolute top-0 -left-1/3 h-full w-1/3 skew-x-[-20deg]" style={{
              background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.18) 50%, transparent 100%)',
              animation: 'mp-shine-sweep 4.5s ease-in-out infinite'
            }} data-id="element-16" data-mp="2z7exr0rfyttx" />
            </span>
          </motion.button>
        </div>
      </header>

      <PremiumCTA data-id="element-17" data-mp="26njf338k0fxs" />

      {/* Sales Copy */}
      <section className="bg-transparent" data-id="element-18" data-mp="26ouobikrqfwa">
        <div className="w-full" data-id="element-19" data-mp="2anla4tjsab43">
          <PainPoints data-id="element-20" data-mp="2aov9dm2dhpcb" />

          <div className="max-w-4xl mx-auto px-4 pl-[0px] pr-[0px]" data-id="element-21" data-mp="2aq6ebp7k1350">
            <DiferencialHibrido data-id="element-22" data-mp="2yehawg67wgnh" />
            <InfraestructuraSistemica data-id="element-23" data-mp="2yga8z72rlsjv" />
          </div>
        </div>
      </section>

      <WhatYouReceive data-id="element-24" data-mp="33f4xmpneybbw" />

      {/* Bonuses */}
      <section className="py-24 bg-transparent relative overflow-hidden pt-[15px] pb-[15px]" data-id="element-25" data-mp="2pmfbml7vx6es">
        {/* Decorative magical background — stars, moons, faint tarot cards */}
        <div aria-hidden="true" className="absolute inset-0 pointer-events-none overflow-hidden" data-id="element-26" data-mp="3hctl858v7wkn">
          {/* Soft radial wash */}
          <div className="absolute inset-0" style={{
          background: 'radial-gradient(ellipse at 20% 10%, rgba(253,224,138,0.08) 0%, transparent 55%), radial-gradient(ellipse at 85% 90%, rgba(124,58,237,0.07) 0%, transparent 55%)'
        }} data-id="element-27" data-mp="3m4tejeufjr89" />

          {/* Faint tarot card silhouettes */}
          <svg className="absolute -left-6 top-12 w-32 h-44 opacity-[0.06] -rotate-12" viewBox="0 0 80 110" fill="none" stroke="#4c1d95" strokeWidth="1.2" data-id="element-28" data-mp="1feq5gny10hcb">
            <rect x="3" y="3" width="74" height="104" rx="6" data-id="element-29" data-mp="mrvt6ebd4o9x" />
            <rect x="9" y="9" width="62" height="92" rx="3" data-id="element-30" data-mp="11oe92cuerwfd" />
            <circle cx="40" cy="55" r="14" data-id="element-31" data-mp="11ls2ogj97myq" />
            <path d="M40 41 L43 51 L53 51 L45 57 L48 67 L40 61 L32 67 L35 57 L27 51 L37 51 Z" data-id="element-32" data-mp="woifl7jc7ne2" />
          </svg>
          <svg className="absolute right-2 top-1/3 w-28 h-40 opacity-[0.05] rotate-[14deg]" viewBox="0 0 80 110" fill="none" stroke="#4c1d95" strokeWidth="1.2" data-id="element-33" data-mp="2d1yugsx8k8j2">
            <rect x="3" y="3" width="74" height="104" rx="6" data-id="element-34" data-mp="honzos1b8wfq" />
            <rect x="9" y="9" width="62" height="92" rx="3" data-id="element-35" data-mp="mmxwf72oo53g" />
            <path d="M40 25 Q55 55 40 90 Q25 55 40 25 Z" data-id="element-36" data-mp="qnhuqdyzter6" />
          </svg>
          <svg className="absolute left-1/4 bottom-10 w-24 h-36 opacity-[0.05] rotate-[6deg]" viewBox="0 0 80 110" fill="none" stroke="#4c1d95" strokeWidth="1.2" data-id="element-37" data-mp="qm6siil74f26">
            <rect x="3" y="3" width="74" height="104" rx="6" data-id="element-38" data-mp="15kioso4nplst" />
            <rect x="9" y="9" width="62" height="92" rx="3" data-id="element-39" data-mp="15ixp6k3hjco3" />
            <circle cx="40" cy="55" r="20" data-id="element-40" data-mp="1acju1q3eqc9c" />
            <circle cx="40" cy="55" r="12" data-id="element-41" data-mp="1adlg0plyoj5u" />
          </svg>

          {/* Minimalist moons */}
          <svg className="absolute right-[8%] top-[8%] w-10 h-10 opacity-30" viewBox="0 0 40 40" fill="none" data-id="element-42" data-mp="1ef6pe0zaefba">
            <path d="M28 6 A16 16 0 1 0 28 34 A12 12 0 1 1 28 6 Z" fill="#d4af37" opacity="0.45" data-id="element-43" data-mp="1ocbeo9ofiqwb" />
          </svg>
          <svg className="absolute left-[10%] bottom-[20%] w-7 h-7 opacity-25" viewBox="0 0 40 40" fill="none" data-id="element-44" data-mp="1tgdlbhokms0i">
            <path d="M28 6 A16 16 0 1 0 28 34 A12 12 0 1 1 28 6 Z" fill="#7c3aed" opacity="0.4" data-id="element-45" data-mp="1ohap8mqkjw4o" />
          </svg>

          {/* Gold stars (twinkling) */}
          {[{
          top: '6%',
          left: '12%',
          size: 10,
          delay: 0
        }, {
          top: '18%',
          left: '48%',
          size: 8,
          delay: 0.6
        }, {
          top: '12%',
          right: '22%',
          size: 12,
          delay: 1.2
        }, {
          top: '55%',
          left: '6%',
          size: 9,
          delay: 0.3
        }, {
          top: '70%',
          right: '12%',
          size: 11,
          delay: 0.9
        }, {
          bottom: '8%',
          left: '38%',
          size: 8,
          delay: 1.5
        }, {
          bottom: '22%',
          right: '38%',
          size: 10,
          delay: 0.4
        }, {
          top: '40%',
          right: '6%',
          size: 7,
          delay: 1.8
        }].map((s, i) => <motion.div key={i} animate={{
          opacity: [0.3, 0.9, 0.3],
          scale: [0.9, 1.15, 0.9]
        }} transition={{
          duration: 3 + i % 3,
          repeat: Infinity,
          delay: s.delay,
          ease: 'easeInOut'
        }} className="absolute" style={{
          top: s.top,
          left: s.left,
          right: s.right,
          bottom: s.bottom
        }} data-id="element-46" data-mp="feft32g3omz4" data-mpi={i}>
              <svg width={s.size} height={s.size} viewBox="0 0 24 24" fill="#d4af37" data-id="element-47" data-mp="3fgmpvp4vb22h">
                <path d="M12 2 L14 9 L21 10 L16 15 L17 22 L12 18 L7 22 L8 15 L3 10 L10 9 Z" data-id="element-48" data-mp="3pczjyo4brhxr" />
              </svg>
            </motion.div>)}

          {/* Soft particles */}
          {[{
          top: '25%',
          left: '20%'
        }, {
          top: '60%',
          left: '70%'
        }, {
          top: '35%',
          left: '80%'
        }, {
          bottom: '30%',
          left: '15%'
        }, {
          bottom: '15%',
          right: '25%'
        }].map((p, i) => <motion.div key={`p-${i}`} animate={{
          y: [0, -10, 0],
          opacity: [0.2, 0.5, 0.2]
        }} transition={{
          duration: 4 + i,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: i * 0.4
        }} className="absolute w-1.5 h-1.5 rounded-full" style={{
          ...p,
          background: 'radial-gradient(circle, rgba(253,224,138,0.8) 0%, transparent 70%)'
        }} data-id="element-49" data-mp="2drj1il7af7kl" data-mpi={i} />)}
        </div>

        <div className="max-container px-4 relative z-10" data-id="element-50" data-mp="1dyug01uch4ic">
          <div className="text-center mb-16" data-id="element-51" data-mp="1ivb4ix5ghkvy">
            <motion.div initial={{
            scale: 0.9,
            opacity: 0
          }} whileInView={{
            scale: 1,
            opacity: 1
          }} viewport={{
            once: true
          }} className="inline-flex items-center justify-center mb-6" data-id="element-52" data-mp="1nv78iwe5lcbi">
              <div className="relative" data-id="element-53" data-mp="np3gmbse4obm">
                <motion.div animate={{
                rotate: [0, -10, 10, -10, 0]
              }} transition={{
                duration: 2,
                repeat: Infinity
              }} className="bg-purple-600 text-white p-4 rounded-2xl shadow-xl relative z-10" data-id="element-54" data-mp="ine56v19a8n0">
                  <Gift size={40} data-id="element-55" data-mp="3woq3hkoc9dv" />
                </motion.div>
                <motion.div animate={{
                scale: [1, 1.2, 1],
                opacity: [0.5, 0.8, 0.5]
              }} transition={{
                duration: 2,
                repeat: Infinity
              }} className="absolute -inset-4 bg-purple-200/30 rounded-full blur-xl" data-id="element-56" data-mp="3w211xa29dp7x" />
              </div>
            </motion.div>

            <h2 className="md:text-7xl font-bold text-purple-950 uppercase italic mb-4 text-[32px] font-magical tracking-tight" data-id="element-57" data-mp="1kbgk1yxgxopa">
              ¡Regalos <span className="text-purple-600" data-id="element-58" data-mp="277zkr10p7muo">Exclusivos!</span>
            </h2>
            <div className="flex items-center justify-center gap-2" data-id="element-59" data-mp="22h9i3vjnpy3o">
              <Sparkles className="text-amber-500 animate-pulse" size={20} data-id="element-60" data-mp="22fg7k55xatqe" />
              <p className="text-purple-600 font-black tracking-[0.2em] uppercase text-sm" data-id="element-61" data-mp="1xhwuh8kyon01">
                100% GRATIS SOLO POR HOY
              </p>
              <Sparkles className="text-amber-500 animate-pulse" size={20} data-id="element-62" data-mp="1oi1duo8mzzsm" />
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-63" data-mp="1ji5dcyz5eqht">
            <BonusCard number="BONO 01" title="Checklist de Preparación" image="https://cdn.magicpatterns.com/uploads/qnHBLUKYy7DnKx8xq2SzXu/Book_cover_for_Bono_1_202605101358.webp" description="Guía rápida para preparar correctamente el espacio energético y emocional antes de cada lectura." originalPrice="$12.500 ARS" value="HOY GRATIS" data-id="element-64" data-mp="1jkrikrykgtwv" />
            <BonusCard number="BONO 02" title="Manual de Interpretación de la Carta Astral" image="https://cdn.magicpatterns.com/uploads/anfLkeSD3oYmS5cK9dr2eL/Book_cover_design_interpretation_202605101358.webp" description="Introducción práctica para integrar elementos astrológicos dentro del acompañamiento terapéutico." originalPrice="$14.900 ARS" value="HOY GRATIS" data-id="element-65" data-mp="3lfp82qp1j17w" />
            <BonusCard number="BONO 03" title="Diario de Armonización y Frecuencia Interior" image="https://cdn.magicpatterns.com/uploads/w8DtoGTLWGdTdacXYbvKbY/Book_cover_for_Bono_3_202605101359.webp" description="Ejercicios guiados para fortalecer conexión interior, presencia y equilibrio energético." originalPrice="$11.200 ARS" value="HOY GRATIS" data-id="element-66" data-mp="32j674ooe4jmf" />
            <BonusCard number="BONO 04" title="Método de Protección y Limpieza Energética" image="https://cdn.magicpatterns.com/uploads/7ffKoPtdj1P1Jd9zVxUDJu/Book_cover_for_Bono_4_202605101401.webp" description="Técnicas prácticas para limpiar, proteger y sostener la energía antes y después de las sesiones." originalPrice="$13.500 ARS" value="HOY GRATIS" data-id="element-67" data-mp="204qynn9ho9z" />
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-12 relative overflow-hidden bg-transparent" data-id="element-68" data-mp="3aisriswp2ijx">
        <div className="max-container px-4 relative z-10" data-id="element-69" data-mp="3p6x8nsg3mm0l">
          <div className="max-w-2xl mx-auto relative" data-id="element-70" data-mp="3kf5g5cddu67t">
            <div className="overflow-hidden" data-id="element-71" data-mp="3kdkqa020jbga">
              <motion.div key={currentTestimonial} drag="x" dragConstraints={{
              left: 0,
              right: 0
            }} onDragEnd={(_, info) => {
              if (info.offset.x > 100) {
                prevTestimonial();
              } else if (info.offset.x < -100) {
                nextTestimonial();
              }
            }} initial={{
              opacity: 0,
              x: 100
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -100
            }} transition={{
              duration: 0.5,
              ease: 'easeOut'
            }} className="bg-white/80 p-6 md:p-8 rounded-3xl border border-purple-100 relative backdrop-blur-sm cursor-grab active:cursor-grabbing shadow-lg premium-shadow" data-id="element-72" data-mp="2wpb8rabu19uy">
                <div className="flex flex-col items-center text-center" data-id="element-73" data-mp="5l6ifipkifm9">
                  <div className="flex-1" data-id="element-74" data-mp="9lgm2opw0txy">
                    <div className="flex justify-center text-purple-500 mb-3 gap-1" data-id="element-75" data-mp="prtkdf8j9yyu">
                      {[...Array(5)].map((_, idx) => <Star key={idx} size={14} fill="currentColor" strokeWidth={1} data-id="element-76" data-mp="l0235vb9p5ld" data-mpi={idx} />)}
                    </div>

                    <p className="text-zinc-800 text-base md:text-lg leading-relaxed font-light italic mb-4" data-id="element-77" data-mp="18qfneznm205e">
                      "{testimonials[currentTestimonial].text}"
                    </p>

                    <div className="pt-3 border-t border-purple-50" data-id="element-78" data-mp="ys878j15bm4g">
                      <h4 className="text-purple-950 font-bold text-base" data-id="element-79" data-mp="yul03r8fzgwa">
                        {testimonials[currentTestimonial].name}
                      </h4>
                      <p className="text-purple-600 font-bold uppercase tracking-widest text-[10px]" data-id="element-80" data-mp="3jjigmlo5yqv0">
                        {testimonials[currentTestimonial].loc} —{' '}
                        {testimonials[currentTestimonial].badge}
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>

            {/* Navigation Arrows */}
            <button onClick={prevTestimonial} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 md:-translate-x-10 bg-white p-2 rounded-full text-purple-600 hover:bg-purple-50 transition-colors z-20 shadow-md border border-purple-100" data-id="element-81" data-mp="23y86ncutejon">
              <ArrowRight className="rotate-180" size={18} data-id="element-82" data-mp="2in49mvi0l6ie" />
            </button>
            <button onClick={nextTestimonial} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 md:translate-x-10 bg-white p-2 rounded-full text-purple-600 hover:bg-purple-50 transition-colors z-20 shadow-md border border-purple-100" data-id="element-83" data-mp="2mrc130fux0kb">
              <ArrowRight size={18} data-id="element-84" data-mp="xajejzirxndk" />
            </button>
          </div>
        </div>
      </section>

      {/* Purchase Section */}
      <section id="purchase" className="py-12 bg-transparent relative overflow-hidden pt-[20px] pb-[20px]" data-id="element-85" data-mp="20micz1ivo27e">
        <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-86" data-mp="29mx0m7jbdte2">
          <div className="max-w-2xl mx-auto" data-id="element-87" data-mp="29o82u2x42t32">
            <div className="bg-[#fffdfa] border border-purple-100 rounded-[3rem] shadow-2xl overflow-hidden premium-shadow relative" data-id="element-88" data-mp="24o3nig7xw4ef">
              {/* Decorative background glow */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-32 bg-gradient-to-b from-purple-50/50 to-transparent pointer-events-none" data-id="element-89" data-mp="2em18muui5l2t" />

              <div className="p-4 md:p-10 flex flex-col items-center text-center relative z-10" data-id="element-90" data-mp="2scwjudsh4e9k">
                {/* Social Proof Header */}
                <div className="mb-6 space-y-1" data-id="element-91" data-mp="32blt5i6b0qe7">
                  <p className="text-purple-600 font-black text-[10px] tracking-[0.25em] uppercase" data-id="element-92" data-mp="32cdqaxfjuw6l">
                    ✦ + <AnimatedCounter from={0} to={joinedCount} data-id="element-93" data-mp="2xe2dqexve7ko" /> ALUMNOS ✦
                  </p>
                  <div className="flex justify-center gap-1.5 text-amber-400" data-id="element-94" data-mp="3gzm1hy8uz1ik">
                    {[...Array(5)].map((_, i) => <Star key={i} size={18} fill="currentColor" className="drop-shadow-[0_0_8px_rgba(251,191,36,0.4)]" data-id="element-95" data-mp="3lv1howuc99i5" data-mpi={i} />)}
                  </div>
                  <p className="text-purple-400/80 font-bold text-[11px] italic" data-id="element-96" data-mp="2y5qbgzu7ymwm">
                    "La formación más completa del mercado"
                  </p>
                </div>

                {/* Product Badge */}
                <div className="mb-8" data-id="element-97" data-mp="2t8q66r571o6k">
                  <div className="inline-block bg-gradient-to-r from-amber-50 to-amber-100/50 border border-amber-200/60 px-6 py-1.5 rounded-full shadow-sm" data-id="element-98" data-mp="2t9rsjrrntx3l">
                    <span className="text-amber-800 font-black text-[10px] uppercase tracking-[0.25em] flex items-center gap-2" data-id="element-99" data-mp="2jaj0j4gcusjv">
                      <Sparkles size={12} className="text-amber-500" data-id="element-100" data-mp="2zqbh7mtq4x2v" />
                      SISTEMA TERAPÉUTICO PROFESIONAL
                      <Sparkles size={12} className="text-amber-500" data-id="element-101" data-mp="2uri25pysgy0l" />
                    </span>
                  </div>
                </div>

                {/* Title */}
                <div className="mb-8 space-y-3" data-id="element-102" data-mp="2ktkd5093ux6x">
                  <h2 className="text-3xl md:text-5xl font-bold text-purple-950 font-magical leading-tight tracking-tight" data-id="element-103" data-mp="2kuvgx02jw4y1">
                    Elegí el camino terapéutico
                    <br data-id="element-104" data-mp="2byw9tfn3bpkr" />
                    <span className="text-amber-600 italic relative inline-block" data-id="element-105" data-mp="2bye7c19u4f4e">
                      que mejor conecte con vos
                      <svg className="absolute -bottom-2 left-0 w-full h-2 text-amber-200/60" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-106" data-mp="222t98e7vzyzx">
                        <path d="M0 5 Q 25 0, 50 5 T 100 5" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-107" data-mp="1t24ufhao5ulz" />
                      </svg>
                    </span>
                  </h2>
                  <p className="text-purple-900/60 font-medium text-sm max-w-md mx-auto leading-relaxed pt-2" data-id="element-108" data-mp="hl1uczj4cyts">
                    Accedé de forma inmediata a nuestros programas profesionales
                    en <strong data-id="element-109" data-mp="3l2sg926r3h6z">formato digital PDF</strong> con acceso de por
                    vida y futuras actualizaciones.
                  </p>
                </div>

                {/* Pack Selection Label */}
                <div className="mb-5" data-id="element-110" data-mp="3ux2dax6n13o1">
                  <p className="text-purple-400 font-black text-[10px] uppercase tracking-[0.3em] flex items-center justify-center gap-3" data-id="element-111" data-mp="3kr520xgjsaq">
                    <span className="animate-bounce" data-id="element-112" data-mp="32a7r9vu69w8g">↓</span> SELECCIONÁ TU PACK{' '}
                    <span className="animate-bounce" data-id="element-113" data-mp="3789kh9lbbbxn">↓</span>
                  </p>
                </div>

                {/* Options Selector */}
                <div className="w-full space-y-4 mb-10" data-id="element-114" data-mp="2lyqbb9t4g424">
                  {options.map(option => <Fragment key={option.id} data-id="element-115" data-mp="27yz0tj1td5sv">
                      <button onClick={() => setSelectedOption(option.id)} className={`${`w-full relative flex items-center gap-4 p-5 rounded-2xl border-2 transition-all duration-500 text-left overflow-hidden group/opt ${selectedOption === option.id ? 'border-purple-500 bg-white shadow-[0_10px_30px_rgba(124,58,237,0.1)] scale-[1.02]' : 'border-purple-50 bg-white/50 hover:border-purple-200 hover:bg-white'}`} pb-[20px]`} data-id="element-116" data-mp="27y79wlj5vw8x">
                        {option.badge && <div className={`absolute -top-0 right-6 px-3 py-1 rounded-b-xl text-[9px] font-black tracking-widest text-white shadow-sm z-10 uppercase ${option.id === 2 ? 'bg-orange-500' : 'bg-purple-600'}`} data-id="element-117" data-mp="1fabctfpok2bm">
                            {option.badge}
                          </div>}

                        <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors duration-300 ${selectedOption === option.id ? 'border-purple-600 bg-purple-600' : 'border-purple-100'}`} data-id="element-118" data-mp="vqcjzn4x4tc4">
                          {selectedOption === option.id && <CheckCircle2 size={14} className="text-white" data-id="element-119" data-mp="1eo5lqm3t2x7x" />}
                        </div>

                        <div className="flex-1 min-w-0" data-id="element-120" data-mp="1tbqoug0okwfu">
                          <h3 className={`font-black text-sm md:text-base leading-tight mb-0.5 transition-colors duration-300 ${selectedOption === option.id ? 'text-purple-950' : 'text-purple-900/40'}`} data-id="element-121" data-mp="1ocnims8ysk6a">
                            {option.name}
                          </h3>
                          <p className={`text-[11px] font-bold truncate transition-colors duration-300 ${selectedOption === option.id ? 'text-purple-500' : 'text-purple-300'}`} data-id="element-122" data-mp="v1qtsnwbheiy">
                            {option.description}
                          </p>
                        </div>

                        <div className="text-right shrink-0" data-id="element-123" data-mp="1dqxegggo8g7e">
                          <p className="text-purple-200 text-[10px] line-through font-bold leading-none mb-1" data-id="element-124" data-mp="1dqf64lgqibj4">
                            ${option.oldPrice}
                          </p>
                          <p className={`text-xl md:text-2xl font-black tracking-tighter ${selectedOption === option.id ? 'text-[#84cc16]' : 'text-purple-200'}`} data-id="element-125" data-mp="1nqftqjlmzdt4">
                            ${option.price}
                          </p>
                        </div>
                      </button>

                      {/* Sub-selector for Option 2 */}
                      {option.id === 2 && selectedOption === 2 && <motion.div initial={{
                    opacity: 0,
                    height: 0
                  }} animate={{
                    opacity: 1,
                    height: 'auto'
                  }} className="px-4 pb-5 space-y-2.5" data-id="element-126" data-mp="3h7lipn69kbxl">
                          <div className="py-2" data-id="element-127" data-mp="3u8qog6md1sa">
                            <p className="text-purple-400 font-black text-[10px] uppercase tracking-[0.25em] text-center flex items-center justify-center gap-2" data-id="element-128" data-mp="3vwq1p6kvuk6r">
                              <Sparkles size={12} className="text-amber-400" data-id="element-129" data-mp="3qx5718cqwxzu" />
                              SELECCIONÁ TU KIT ADICIONAL
                              <Sparkles size={12} className="text-amber-400" data-id="element-130" data-mp="2fiht6fwy6be4" />
                            </p>
                          </div>
                          <div className="grid grid-cols-1 gap-2" data-id="element-131" data-mp="78qp7bf9stsy">
                            {kits.map(kit => <button key={kit.id} onClick={() => setSelectedKit(kit.id)} className={`flex items-center justify-between p-4 rounded-xl border-2 transition-all duration-300 ${selectedKit === kit.id ? 'border-purple-400 bg-white shadow-md scale-[1.01]' : 'border-purple-50 bg-purple-50/30 hover:border-purple-100'}`} data-id="element-132" data-mp="c236t1lj80c7">
                                <div className="flex items-center gap-3" data-id="element-133" data-mp="h04phlf1pxn5">
                                  <span className="text-xl" data-id="element-134" data-mp="lyo7jaqiqpa8">{kit.icon}</span>
                                  <span className={`text-[11px] font-bold ${selectedKit === kit.id ? 'text-purple-900' : 'text-purple-900/40'}`} data-id="element-135" data-mp="m0snws5ltgre">
                                    {kit.name}
                                  </span>
                                </div>
                                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors duration-300 ${selectedKit === kit.id ? 'border-purple-600 bg-purple-600' : 'border-purple-100'}`} data-id="element-136" data-mp="2u6ui7l0wldss">
                                  {selectedKit === kit.id && <CheckCircle2 size={12} className="text-white" data-id="element-137" data-mp="2ff2ds42ndk5u" />}
                                </div>
                              </button>)}
                          </div>
                        </motion.div>}
                    </Fragment>)}
                </div>

                {/* Product Image */}
                <div className="w-full overflow-hidden rounded-[2rem] shadow-2xl border border-purple-100 bg-white p-2 pt-[0px] pb-[0px] mb-[15px]" data-id="element-138" data-mp="3rullqqd8hs46">
                  <div className="rounded-[1.5rem] overflow-hidden" data-id="element-139" data-mp="ly009b302w3">
                    <AnimatePresence mode="wait" data-id="element-140" data-mp="5fsjbbmryfun">
                      <motion.img key={displayImage} initial={{
                      opacity: 0,
                      scale: 0.95
                    }} animate={{
                      opacity: 1,
                      scale: 1
                    }} exit={{
                      opacity: 0,
                      scale: 1.05
                    }} transition={{
                      duration: 0.4,
                      ease: 'easeOut'
                    }} src={displayImage} alt={selectedData.name} className="w-full h-auto" data-id="element-141" data-mp="9g2zti870onr" />
                    </AnimatePresence>
                  </div>
                </div>

                {/* Final Pricing & CTA */}
                <div className="w-full space-y-6" data-id="element-142" data-mp="12i3t8mizlhwv">
                  <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#84cc16] to-[#65a30d] text-white px-6 py-2 rounded-full font-black uppercase tracking-[0.15em] shadow-lg text-[11px]" data-id="element-143" data-mp="12gsnwi9w823n">
                    <Zap size={14} fill="currentColor" data-id="element-144" data-mp="tfuka13d9wll" /> 50% OFF SOLO POR HOY
                  </div>

                  <div className="flex flex-col items-center" data-id="element-145" data-mp="olgv4gfaslpd">
                    <div className="bg-purple-50/40 border border-purple-100/60 rounded-2xl px-6 py-3 inline-flex flex-col items-center shadow-sm pt-[0px] pb-[0px] pl-[24px] pr-[24px] gap-[0px]" data-id="element-146" data-mp="jkjew9dum1qi">
                      <p className="text-purple-900/40 font-bold text-[10px] uppercase tracking-[0.2em]" data-id="element-147" data-mp="2dwr1mzg0ncb7">
                        3 cuotas sin interés de
                      </p>
                      <p className="text-[#84cc16] font-black md:text-4xl tracking-tighter text-[20px]" data-id="element-148" data-mp="2t69s64tlmbhy">
                        $
                        {(parseFloat(selectedData.price.replace('.', '')) / 3).toLocaleString('es-AR', {
                        maximumFractionDigits: 0
                      })}
                      </p>
                    </div>
                  </div>

                  <div className="relative group/cta" data-id="element-149" data-mp="29jc6418z3pcq">
                    {/* Magical Glow Aura */}
                    <motion.div animate={{
                    opacity: [0.4, 0.8, 0.4],
                    scale: [1, 1.05, 1]
                  }} transition={{
                    duration: 3,
                    repeat: Infinity,
                    ease: 'easeInOut'
                  }} className="absolute -inset-2 bg-[#84cc16]/20 blur-xl rounded-3xl pointer-events-none" data-id="element-150" data-mp="2ee7xcz6dy8os" />

                    {/* Twinkling Sparkles around button */}
                    {[...Array(6)].map((_, i) => <motion.div key={i} animate={{
                    opacity: [0, 1, 0],
                    scale: [0, 1, 0],
                    rotate: [0, 180]
                  }} transition={{
                    duration: 2 + Math.random(),
                    repeat: Infinity,
                    delay: Math.random() * 2
                  }} className="absolute text-amber-400 pointer-events-none z-10" style={{
                    top: `${Math.random() * 100}%`,
                    left: `${Math.random() * 100}%`
                  }} data-id="element-151" data-mp="mkhzfgtml7za" data-mpi={i}>
                        <Sparkles size={12 + Math.random() * 8} fill="currentColor" data-id="element-152" data-mp="33aq80y72vslr" />
                      </motion.div>)}

                    <motion.a href={finalLink} target="_blank" rel="noopener noreferrer" whileHover={{
                    scale: 1.02
                  }} whileTap={{
                    scale: 0.98
                  }} className="relative w-full bg-[#84cc16] hover:bg-[#65a30d] text-white py-4 rounded-2xl font-black text-2xl md:text-3xl flex items-center justify-center gap-3 transition-all shadow-[0_10px_20px_rgba(132,204,22,0.2)] uppercase tracking-tighter overflow-hidden" data-id="element-153" data-mp="1dl7uv4cb3o25">
                      {/* Shimmer Sweep Animation */}
                      <motion.div animate={{
                      x: ['-100%', '200%']
                    }} transition={{
                      duration: 3,
                      repeat: Infinity,
                      ease: 'easeInOut',
                      repeatDelay: 1
                    }} className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-[-20deg] pointer-events-none" data-id="element-154" data-mp="2k57b98f4i5x5" />
                      <Sparkles className="text-amber-300 animate-pulse" size={24} data-id="element-155" data-mp="2g2zex1ybxij7" />
                      ACCEDER AHORA
                      <Sparkles className="text-amber-300 animate-pulse" size={24} data-id="element-156" data-mp="266mnkaq9bgrm" />
                    </motion.a>
                  </div>

                  {/* Urgency Indicators */}
                  <div className="space-y-5 pt-2" data-id="element-157" data-mp="1x79dbfub6o5u">
                    <div className="flex items-center justify-center gap-3 bg-orange-50 py-2 px-6 rounded-full border border-orange-100 inline-flex mx-auto" data-id="element-158" data-mp="222omvvla9xwg">
                      <motion.span animate={{
                      scale: [1, 1.3, 1],
                      rotate: [-10, 10, -10]
                    }} transition={{
                      duration: 1.5,
                      repeat: Infinity
                    }} className="text-xl" data-id="element-159" data-mp="2xb7s0r4679j">
                        🔥
                      </motion.span>
                      <p className="text-orange-600 font-black text-sm uppercase tracking-wider" data-id="element-160" data-mp="llg4wpd9mtzd">
                        ¡Últimos {spots} cupos en oferta!
                      </p>
                    </div>

                    <div className="space-y-3" data-id="element-161" data-mp="cp7539ldltcp">
                      <div className="flex gap-1 flex-row items-center justify-center" data-id="element-162" data-mp="32d7slu0n1jm1">
                        <div className="flex items-center gap-2 text-purple-400 font-black text-[10px] uppercase tracking-[0.3em]" data-id="element-163" data-mp="2xctv35wnxs29">
                          <Clock size={14} className="animate-pulse" data-id="element-164" data-mp="1cwlytoh0xf12" /> LA
                          OFERTA EXPIRA EN:
                        </div>
                        <motion.div animate={{
                        scale: [1, 1.02, 1]
                      }} transition={{
                        duration: 2,
                        repeat: Infinity
                      }} className="text-purple-600 font-black md:text-5xl tracking-tighter tabular-nums drop-shadow-[0_0_15px_rgba(124,58,237,0.2)] text-[18px]" data-id="element-165" data-mp="1lvzcktc6kprl">
                          {String(timeLeft.minutes).padStart(2, '0')}:
                          {String(timeLeft.seconds).padStart(2, '0')}
                        </motion.div>
                      </div>
                      <div className="w-full h-2 bg-zinc-100 rounded-full overflow-hidden shadow-inner max-w-xs mx-auto" data-id="element-166" data-mp="f70xpmyqm7p6">
                        <motion.div className="h-full bg-gradient-to-r from-purple-500 to-purple-700 shadow-[0_0_10px_rgba(124,58,237,0.4)]" initial={{
                        width: '100%'
                      }} animate={{
                        width: `${(timeLeft.minutes * 60 + timeLeft.seconds) / 900 * 100}%`
                      }} transition={{
                        duration: 1
                      }} data-id="element-167" data-mp="3g1gr9r05dqxd" />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Trust Icons Section */}
                <div className="w-full border-t border-dashed border-purple-200 pt-[0px] mt-[0px] space-y-[0px]" data-id="element-168" data-mp="329iodxx14r9n">
                  <div className="flex flex-col items-center gap-2" data-id="element-169" data-mp="2ejof1qbx5ku5"></div>

                  {/* Payment Methods Image */}
                  <div className="w-full bg-white p-4 rounded-2xl border border-purple-50 shadow-sm" data-id="element-170" data-mp="p4dnvha0khyp">
                    <img src="https://cdn.magicpatterns.com/uploads/qqt2cRPGWCZJ3RZPqT8yo9/capture_260410_163646.png" alt="Pago seguro garantizado" className="w-full h-auto" data-id="element-171" data-mp="tv3t8uifwkte" />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-172" data-mp="k2y0vjoa01do">
                    {/* MercadoLíder Platinum Image */}
                    <div className="w-full bg-white p-2 rounded-2xl border border-purple-50 shadow-sm overflow-hidden" data-id="element-173" data-mp="1cuhp5hzqc5mj">
                      <img src="https://cdn.magicpatterns.com/uploads/mnM7mWp1H3pymbzqwPchpK/7ef4071d-c511-4325-9d9d-f2158f7b8632.jpg" alt="MercadoLíder Platinum" className="w-full h-auto rounded-xl" data-id="element-174" data-mp="yt5cpgjs2m5e" />
                    </div>

                    {/* Purchase Protection Box */}
                    <div className="bg-gradient-to-br from-blue-50/50 to-indigo-50/30 border border-blue-100 rounded-2xl p-6 flex flex-col justify-center space-y-6" data-id="element-175" data-mp="1u3tqd83mfc8c">
                      <p className="text-blue-900 font-black text-[11px] uppercase tracking-[0.25em]" data-id="element-176" data-mp="1p6aay4v6stet">
                        GARANTÍA DE SATISFACCIÓN Y SEGURIDAD
                      </p>
                      <div className="flex items-center justify-center md:gap-10 gap-[0px]" data-id="element-177" data-mp="1g9t0l3unczk4">
                        <img src="https://cdn.magicpatterns.com/uploads/jE7r9b5VQj7LAkmtvSfrCa/png-clipart-safe-purchase-payment-security-shop-shopping-online-store-e-commerce-sign-green-texta.png" alt="Compra Segura" className="h-16 md:h-24 object-contain drop-shadow-md" data-id="element-178" data-mp="1be3zgw2zbalp" />
                        <img src="https://cdn.magicpatterns.com/uploads/fpbSfdYZaTGuGJTHBKUizP/Selo_de_Garantia_de_7_Dias_PNG_Transparente_Sem_Fundo.png" alt="Garantía de 7 Días" className="h-16 md:h-24 object-contain drop-shadow-md" data-id="element-179" data-mp="2vrcouzpu0byp" />
                        <img src="https://cdn.magicpatterns.com/uploads/wKXB12Wvt3nPqQAamPsV1z/Diseno_sin_titulo.png" alt="Acceso de por vida" className="h-16 md:h-24 object-contain drop-shadow-md" data-id="element-180" data-mp="ig1g2hwp53ww" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <TherapistPresentation data-id="element-181" data-mp="3jsjjo46x4o6" />

      <Reviews data-id="element-182" data-mp="8k6vhh8wwyrh" />

      <FAQ data-id="element-183" data-mp="8kq0xyhdluom" />

      <footer className="py-12 border-t border-purple-100 text-center text-zinc-400 text-sm" data-id="element-184" data-mp="8kgicvynupsy">
        <p data-id="element-185" data-mp="1f120o3zujkmb">
          © 2025 Sistema de Tarot Terapéutico. Todos los derechos reservados.
        </p>
      </footer>
    </div>;
}